<template>
    <div class="header">
        <img class="logo" src="../assets/img/logo.png" title="logo">
    </div>
</template>

<script>
export default {
  data(){
    return {

    }
  }
}
</script>

<style lang="less" scoped>
    .header {
        position: fixed;
        top:0;
        z-index:2;
        height: 50px;

        .logo {
            display:block;
            width: 162px;
            height: 16px;
            margin-top: 17px;
            margin-left: 28px;
        }
    }
</style>